import { CongregacionFiltro } from '../enums/congregacion-filtro.enum';

export interface CongregacionFiltroCopy {
  titulo: string;
  detalle: string;
}

const COPY: Record<string, CongregacionFiltroCopy> = {
  [CongregacionFiltro.Ninguno]: {
    titulo: 'Ningún filtro aplicado.',
    detalle: 'Todos los miembros de su congregación están aquí.',
  },
  [CongregacionFiltro.Muelle]: {
    titulo: 'Filtro: Muelle.',
    detalle: 'Estás viendo todos los miembros que aún no tienen líder.',
  },
  [CongregacionFiltro.Faltas]: {
    titulo: 'Filtro: Lista roja.',
    detalle:
      'Personas de 12 años o más que se ausentaron dos domingos consecutivos o más.',
  },
  [CongregacionFiltro.Monitoreo]: {
    titulo: 'Filtro: Monitoreo.',
    detalle: 'El líder de las personas listadas aún no informó su asistencia.',
  },
  [CongregacionFiltro.Cumple]: {
    titulo: 'Filtro: Cumpleaños.',
    detalle: 'Estos son los cumpleaños en los siguientes próximos 30 días.',
  },
  [CongregacionFiltro.Estudiantes]: {
    titulo: 'Filtro: Estudiantes y Bautismos.',
    detalle: 'Personas que están estudiando y Personas inscriptas al próximo bautismo.',
  },
  [CongregacionFiltro.Lideres]: {
    titulo: 'Filtro: Líderes.',
    detalle: 'Personas con rol de líder, admin o contador en la congregación.',
  },
  [CongregacionFiltro.PorNombre]: {
    titulo: 'Filtro: Por nombre.',
    detalle: 'Buscá por nombre o apellido en el campo de la izquierda.',
  },
};

export function congregacionFiltroCopy(filtro: CongregacionFiltro | string): CongregacionFiltroCopy {
  return COPY[filtro] ?? COPY[CongregacionFiltro.Ninguno];
}
